import { LucideIconData } from 'lucide-angular';

export const PoolCaC7: LucideIconData = [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['circle', { cx: '12', cy: '8', r: '2' }],
  ['path', { d: 'M12 11 v7' }],
  ['path', { d: 'M7 15 Q12 20 17 15' }],
];
